import {
  callCallback,
  coloredText,
  createContentRequest,
  getPosterUrl,
  stopLoadingShowError,
} from "../utils";
import * as tvx from "../lib/tvx-plugin-module.min";
import {
  MSXMenuRoot,
  MSXContentRoot,
  Tools,
  MSXContentItem,
  MSXContentPage,
} from "../lib/tvx-plugin-module.min";
import {
  res_blackColor,
  res_charts,
  res_movies,
  res_yellowColor,
} from "../static-res";
import { getCharts, getPageCollections } from "../api/worker";
import {
  apiChart,
  apiCollectionFiction,
  apiCountry,
  apiFiction,
  PagesEnum,
} from "../api/api-models";
import { createCollectionRow } from "./collections-row";
import {
  getCurrentlyDisplayingItemByIndex,
  getDisplayedItems,
} from "./content-utils";

export function createChartsRoot(callback: (data: any) => void): void {
  console.log("createChartsRoot called");
  tvx.InteractionPlugin.stopLoading();
  getCharts().then((charts) => {
    console.log("getCharts result:", charts);
    if (charts != null && charts.length > 0) {
      console.log("Creating charts root with", charts.length, "charts");
      const chartsRoot: MSXContentRoot = {
        cache: true,
        restore: true,
        reuse: true,
        type: "list",
        headline: res_charts(),
        flag: "charts",
        important: true,
        pages: [],
      };
      charts.forEach((chart) => {
        chartsRoot.pages.push(createChartRow(chart));
      });
      callCallback(chartsRoot, callback);
    } else {
      console.log("Charts API returned null or empty array");

      stopLoadingShowError({}, callback);
    }
  }).catch((error) => {
    console.error("Error fetching charts:", error);
    stopLoadingShowError({}, callback);
  });
}
const chartsCorouselsPositions: Map<string, number> = new Map();
const chartsCollections: apiCountry[] = [];

export function getDestFictionByChartId(
  collectionId: string,
  itemIndex: string
): apiCollectionFiction {
  const movies = chartsCollections.find(
    (collection) => collection.id == collectionId
  ).fictions;

  const listIndex = chartsCorouselsPositions.get(collectionId);

  return getCurrentlyDisplayingItemByIndex(
    movies,
    listIndex,
    Number.parseInt(itemIndex)
  );
}
export function updateChartRow(countryId: string, type: number): void {
  const country = chartsCollections.find((country) => country.id == countryId);
  const oldIndex = chartsCorouselsPositions.get(countryId);
  const displaingFictions = getDisplayedItems(country.fictions, oldIndex, type);
  console.log(displaingFictions);

  chartsCorouselsPositions.set(countryId, displaingFictions.newIndex);

  for (let i = 0; i < displaingFictions.items.length; i++) {
    const fictionRoot = displaingFictions.items[i] as apiCollectionFiction;
    const fiction = fictionRoot.fiction;
    const movieOrSerial =
      fiction.kind == "movie" ? fiction.movie : fiction.serial;
    const fictionImage = movieOrSerial.portraitImage;
    tvx.InteractionPlugin.executeAction(
      `update:content:charts-${countryId}-${i + 1}`,
      {
        image: fictionImage,
        title: movieOrSerial.title.toUpperCase(),
        tag: coloredText(res_blackColor, fictionRoot.position.toString()),
      }
    );
  }

  tvx.InteractionPlugin.stopLoading();
}

export function createChartRow(chart: apiChart): MSXContentPage {
  if (chart.countries.length != 0) {
    const country = chart.countries[0];
    if (country.fictions.length != 0) {
      chartsCorouselsPositions.set(country.id, 0);
      chartsCollections.push(country);
      const collectionRowPage: MSXContentPage = {
        headline: chart.name.toUpperCase(),
        items: [
          {
            type: "teaser",
            layout: `0,0,12,1`,
            title: chart.name,
            centration: "title",
          },
          {
            id: `charts-${country.id}-back`,
            type: "default",
            layout: `0,1,1,3`,
            display: country.fictions.length > 5,
            icon: "arrow-back-ios",
            iconSize: "small",
            action: `interaction:commit:message:content:fictions:charts:back:${country.id}`,
          },
          {
            id: `charts-${country.id}-forward`,
            type: "default",
            display: country.fictions.length > 5,
            layout: `11,1,1,3`,
            icon: "arrow-forward-ios",
            iconSize: "small",
            action: `interaction:commit:message:content:fictions:charts:forward:${country.id}`,
          },
        ],
      };
      for (let i = 0; i < Math.min(5, country.fictions.length); i++) {
        collectionRowPage.items.push(
          createChartFictionItem(country.id, country.fictions[i], i + 1)
        );
        console.log(collectionRowPage.items);
      }
      return collectionRowPage;
    }
  }
}

function createChartFictionItem(
  countryId: string,
  fiction: apiCollectionFiction,
  index: number
): MSXContentItem {
  const object =
    fiction.fiction.kind == "movie"
      ? fiction.fiction.movie
      : fiction.fiction.serial;
  return {
    id: `charts-${countryId}-${index}`,
    type: "separate",
    layout: `${index * 2 - 1},1,2,4`,
    image: getPosterUrl(object.imdbid, object.portraitImage),
    title: object.title.toUpperCase(),
    tag: coloredText(res_blackColor, fiction.position.toString()),
    tagColor: res_yellowColor,
    action:
      "content:" + createContentRequest(`fiction:charts:${countryId}:${index}`),
  };
}
